// extracted by mini-css-extract-plugin
export var related_links = "RelatedLinks-module--related_links--135b5";
export var title = "RelatedLinks-module--title--aeb33";
export var type = "RelatedLinks-module--type--b6169";